module.exports = __webpack_public_path__ + "img/mobile_map_gemonadelfriuli.2630c055.svg";